import { OrderItem } from '@libs/api-reference';

import { isNewOms } from '../composables/useGetOmsStatusQuery';
import {
  LEGACY_ORDER_STATUSES_GROUPS,
  NEW_OMS_ORDER_STATUSES_GROUPS,
  ORDER_FILTERS,
} from '../constants';

const getFilteredOrders = (orders: OrderItem[], filter: string) => {
  if (filter === ORDER_FILTERS.all.value) {
    return orders;
  }

  const statusGroups = isNewOms.value
    ? NEW_OMS_ORDER_STATUSES_GROUPS
    : LEGACY_ORDER_STATUSES_GROUPS;

  return orders.filter((order) =>
    statusGroups[filter]?.includes(order.orderStateId)
  );
};

export { getFilteredOrders };
